import axios from 'axios';

import { Payment } from '../types';

export const fetchPayments = (brandId: number) =>
  axios.get<Payment[]>(`/api/brands/${brandId}/payment_methods`);
